import React from "react";
import "./Hero.css";

const Hero = () => {
	return (
		<section className="hero">
			<div className="hero-image">
				<img src="/cover.jpg?v=20261021" alt="NovamaS moda" />
			</div>
			<div className="container">
				<div className="hero-content">
					<h1>
						<span className="hero-brand">NovamaS</span>
						<span className="hero-tagline">
							Svijet stila, ljepote i inspiracije
						</span>
					</h1>
				</div>
			</div>
		</section>
	);
};

export default Hero;
